import styled from 'styled-components';
import { TTheme } from '@pb/styles';
import { Heading } from '@pb/shared/ui/atoms/heading';
import {
    TSecondaryCalloutMessageStatus,
    TStyledSecondaryCalloutMessageMessage,
} from './secondary-callout-message.types';

function handleSecondaryCalloutMessageStatus(
    status: TSecondaryCalloutMessageStatus,
    theme: TTheme
): string {
    switch (status) {
        case 'action':
            return `${theme.color.purple}`;

        case 'success':
            return `${theme.color.green}`;

        case 'warning':
            return `${theme.color.orange}`;

        case 'error':
            return `${theme.color.red}`;

        case 'information':
        default:
            return `${theme.color.indigo}`;
    }
}

export const StyledContentContainer = styled.div`
    width: fit-content;
    margin: 1.2rem 1.6rem 1.6rem;

    p:last-child {
        margin-bottom: 0;
    }
`;

export const StyledWrapper = styled.div<TStyledSecondaryCalloutMessageMessage>`
    display: flex;
    align-items: flex-start;
    box-sizing: border-box;
    width: 100%;
    border: 0.1rem solid ${({ theme }) => theme.color.grey5};
    border-left: 0.8rem solid
        ${({ status, theme }) =>
            handleSecondaryCalloutMessageStatus(status, theme)};
    border-radius: ${({ theme }) => theme.borderRadius.default};
`;

export const StyledSecondaryCalloutMessageHeading = styled(Heading)`
    && {
        margin-top: 0.3rem;

        @media (min-width: ${({ theme }) =>
                theme.deprecatedScreen.tabletPortraitMinimum}) {
            margin-top: 0.2rem;
        }

        @media (min-width: ${({ theme }) =>
                theme.deprecatedScreen.tabletLandscapeMinimum}) {
            margin-top: 0.1rem;
        }
    }
`;

export const StyledSecondaryCalloutMessageIcon = styled.div`
    flex-shrink: 0;
    margin-top: 1.2rem;
    margin-left: 1.2rem;
`;
